// =============================================================================
// API 配置文件
// =============================================================================

// 获取环境变量
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

// API 基础配置
export const API_CONFIG = {
  // 基础 URL
  BASE_URL: import.meta.env.VITE_API_BASE_URL || (isDevelopment ? 'http://localhost:3000' : 'https://space.xiaoyanmao.com'),
  
  // WebSocket URL
  WS_BASE_URL: import.meta.env.VITE_WS_BASE_URL || (isDevelopment ? 'ws://localhost:3000' : 'wss://space.xiaoyanmao.com'),
  
  // 环境信息
  MODE: import.meta.env.VITE_MODE || 'standalone',
  NODE_ENV: import.meta.env.VITE_NODE_ENV || (isProduction ? 'production' : 'development'),
  
  // 超时配置
  TIMEOUT: 30000,
  
  // 重试配置
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// API 端点配置
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    VERIFY: '/api/auth/verify',
    REFRESH: '/api/auth/refresh',
  },
  
  // 工作空间相关
  WORKSPACES: {
    LIST: '/api/plugin/workspaces',
    CREATE: '/api/plugin/workspaces',
    DETAIL: '/api/plugin/workspaces/:id',
    ACTION: '/api/plugin/workspaces/:id/:action',
    DELETE: '/api/plugin/workspaces/:id',
  },
  
  // 终端相关
  TERMINALS: {
    LIST: '/api/plugin/terminals',
    CREATE: '/api/plugin/terminals',
    DETAIL: '/api/plugin/terminals/:id',
    DELETE: '/api/plugin/terminals/:id',
  },
  
  // 系统相关
  SYSTEM: {
    HEALTH: '/health',
    VERSION: '/api/version',
    STATUS: '/api/status',
  },
  
  // 插件相关
  PLUGIN: {
    PANEL: '/plugin/panel',
    TERMINAL: '/plugin/terminal/:id',
  },
};

// WebSocket 端点配置
export const WS_ENDPOINTS = {
  TERMINAL: '/terminal',
  SHELL: '/shell',
  WORKSPACE: '/workspace',
};

// 构建完整的 API URL
export const buildApiUrl = (endpoint, params = {}) => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  // 替换路径参数
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// 构建完整的 WebSocket URL
export const buildWsUrl = (endpoint, params = {}) => {
  let url = `${API_CONFIG.WS_BASE_URL}${endpoint}`;
  
  // 替换路径参数
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// 获取认证头
export const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// 默认请求配置
export const DEFAULT_REQUEST_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    ...getAuthHeaders(),
  },
  timeout: API_CONFIG.TIMEOUT,
};

// 环境信息
export const ENV_INFO = {
  isDevelopment,
  isProduction,
  mode: API_CONFIG.MODE,
  nodeEnv: API_CONFIG.NODE_ENV,
  baseUrl: API_CONFIG.BASE_URL,
  wsBaseUrl: API_CONFIG.WS_BASE_URL,
};

// 调试信息
if (isDevelopment) {
  console.log('🔧 API Configuration:', {
    baseUrl: API_CONFIG.BASE_URL,
    wsBaseUrl: API_CONFIG.WS_BASE_URL,
    mode: API_CONFIG.MODE,
    nodeEnv: API_CONFIG.NODE_ENV,
  });
}

export default API_CONFIG;
